import RequireAuth from '@converge/ui/domain/auth/require-auth';
import BrokerTabs from '../../../../../../../frontend/libs/ui/src/domain/entity/broker-agencies/broker-form/broker-tabs';

export const BrokerDetailPage = () => {
  return (
    <RequireAuth>
      <BrokerTabs />
    </RequireAuth>
  );
};

export default BrokerDetailPage;
